import BillingScreen from '@features/accountsSettings/components/billing/index'
import ConsentTemplateView from '@features/accountsSettings/components/consentTemplates/ConsentTemplateView'
import ConsentTemplateLibrary from '@features/accountsSettings/components/consentTemplates/index'
import SecondSignatureSettingsScreen from '@features/accountsSettings/components/emarSettings/SecondSignatureSettingsScreen'
import FamilyInviteScreen from '@features/accountsSettings/components/familySettings/FamilyInviteScreen'
import FamilySettingsScreen from '@features/accountsSettings/components/familySettings/FamilySettingsScreen'
import HomeSettingsScreen from '@features/accountsSettings/components/homeSettings/HomeSettingsFeatureFlagWrapper'
import IncidentReportSettingsScreen from '@features/accountsSettings/components/IncidentReportsSettingsScreen'
import MemberBenefits from '@features/accountsSettings/components/memberBenefits/index'
import MonitoringReportSettingsScreen from '@features/accountsSettings/components/monitoringReportSettings/MonitoringReportSettingsScreen'
import NeedTemplateScreen from '@features/accountsSettings/components/skillsAndNeeds/NeedTemplateScreen'
import SkillTemplateScreen from '@features/accountsSettings/components/skillsAndNeeds/SkillTemplateScreen'
import ZonesScreen from '@features/accountsSettings/components/zones/index'
import AccountsSettingsScreen from '@features/accountsSettings/screens/AccountSettingsView'
import AccessControl from 'components/AccessControl/AccessControl'
import { Features } from 'components/AccessControl/useFeatures'
import { Route } from 'react-router-dom'
import { PrivacyOfficersScreen } from 'screens/AccountsSettings'
import CarePackageSettingsScreen from 'screens/Rostering/siteSettings/CarePackageSettings'
import ContractsAndAbsenceSettingsScreen from 'screens/Rostering/siteSettings/ContractsAndAbsenceSettings'
import FinanceSettingsScreen from 'screens/Rostering/siteSettings/FinanceSettings'
import GeofencingSettingsScreen from 'screens/Rostering/siteSettings/GeofencingSettings'
import PayRatesSettingsScreen from 'screens/Rostering/siteSettings/PayRatesSettings'
import RotaPatternsSettings from 'screens/Rostering/siteSettings/RotaPatternsSettings'
import TravelTimeAndMileageSettingsScreen from 'screens/Rostering/siteSettings/TravelTimeAndMileageSettings'
import WarningsSettingsScreen from 'screens/Rostering/siteSettings/WarningsSettings'
import { ID } from './utils'

const SETTINGS_PATH = 'settings'
const BILLING = 'billing'
const HOME_SETTINGS = `home-${SETTINGS_PATH}`
const FAMILY_SETTINGS = `family-${SETTINGS_PATH}`
const FAMILY_INVITE = 'family-invite'
const ZONES = 'zones'
const EMAR = 'emar'
const SECOND_SIGNATURE = 'second-signature'
const MONITORING_REPORTS = 'monitoring-report-settings'
const INCIDENT_REPORTS = 'incident-reports-settings'
const PERKS = 'perks'
const CONSENT_TEMPLATES = 'consent-templates'
const SKILLS_AND_NEEDS = 'skills-and-needs'
const SKILL_TEMPLATES = 'skill-templates'
const NEED_TEMPLATES = 'need-templates'
const PRIVACY_OFFICERS = 'privacy-officers'
const CARE_PACKAGE = 'care-package'
const CONTRACTS_AND_ABSENCES = 'contracts-and-absences'
const WARNINGS = 'warnings'
const ROTA_PATTERNS = 'rota-patterns'
const TRAVEL_TIME_AND_MILEAGE = 'travel-time-and-mileage'
const GEOFENCING = 'geofencing'
const PAY_RATES = 'pay-rates'
const FINANCE = 'finance'
export const SETTINGS = {
  INDEX: `${SETTINGS_PATH}`,
  BILLING: `${SETTINGS_PATH}/${BILLING}`,
  HOME_SETTINGS: `${SETTINGS_PATH}/${HOME_SETTINGS}`,
  FAMILY_SETTINGS: `${SETTINGS_PATH}/${FAMILY_SETTINGS}`,
  FAMILY_INVITE: `${SETTINGS_PATH}/${FAMILY_INVITE}`,
  ZONES: `${SETTINGS_PATH}/zones`,
  EMAR_SECOND_SIGNATURE: `${SETTINGS_PATH}/${EMAR}/${SECOND_SIGNATURE}`,
  PERKS: `${SETTINGS_PATH}/perks`,
  CONSENT_TEMPLATES: `${SETTINGS_PATH}/${CONSENT_TEMPLATES}`,
  CONSENT_TEMPLATE_ID: `${SETTINGS_PATH}/${CONSENT_TEMPLATES}/${ID}`,
  SKILLS_AND_NEEDS: `${SETTINGS_PATH}/${SKILLS_AND_NEEDS}`,
  SKILL_TEMPLATES: `${SETTINGS_PATH}/${SKILLS_AND_NEEDS}/${SKILL_TEMPLATES}`,
  NEED_TEMPLATES: `${SETTINGS_PATH}/${SKILLS_AND_NEEDS}/${NEED_TEMPLATES}`,
  PRIVACY_OFFICERS: `${SETTINGS_PATH}/${PRIVACY_OFFICERS}`,
  CARE_PACKAGE: `${SETTINGS_PATH}/${CARE_PACKAGE}`,
  CONTRACTS_AND_ABSENCES: `${SETTINGS_PATH}/${CONTRACTS_AND_ABSENCES}`,
  WARNINGS: `${SETTINGS_PATH}/${WARNINGS}`,
  ROTA_PATTERNS: `${SETTINGS_PATH}/${ROTA_PATTERNS}`,
  TRAVEL_TIME_AND_MILEAGE: `${SETTINGS_PATH}/${TRAVEL_TIME_AND_MILEAGE}`,
  GEOFENCING: `${SETTINGS_PATH}/${GEOFENCING}`,
  PAY_RATES: `${SETTINGS_PATH}/${PAY_RATES}`,
  FINANCE: `${SETTINGS_PATH}/${FINANCE}`
}

export const settingsRoutes = (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <Route path={SETTINGS_PATH} element={<AccountsSettingsScreen />}>
    <Route path={BILLING} element={<BillingScreen />} />
    <Route path={HOME_SETTINGS} element={<HomeSettingsScreen />} />
    <Route path={INCIDENT_REPORTS} element={<IncidentReportSettingsScreen />} />
    <Route
      path={FAMILY_SETTINGS}
      element={
        <AccessControl features={[Features.FAMILY]}>
          <FamilySettingsScreen />
        </AccessControl>
      }
    />
    <Route
      path={FAMILY_INVITE}
      element={
        <AccessControl features={[Features.FAMILY]}>
          <FamilyInviteScreen />
        </AccessControl>
      }
    />
    <Route path={ZONES} element={<ZonesScreen />} />
    <Route
      path={`${EMAR}/${SECOND_SIGNATURE}`}
      element={<SecondSignatureSettingsScreen />}
    />
    <Route
      path={MONITORING_REPORTS}
      element={<MonitoringReportSettingsScreen />}
    />
    <Route path={CARE_PACKAGE} element={<CarePackageSettingsScreen />} />
    <Route
      path={CONTRACTS_AND_ABSENCES}
      element={<ContractsAndAbsenceSettingsScreen />}
    />
    <Route path={WARNINGS} element={<WarningsSettingsScreen />} />
    <Route path={ROTA_PATTERNS} element={<RotaPatternsSettings />} />
    <Route
      path={TRAVEL_TIME_AND_MILEAGE}
      element={<TravelTimeAndMileageSettingsScreen />}
    />
    <Route path={GEOFENCING} element={<GeofencingSettingsScreen />} />
    <Route path={PAY_RATES} element={<PayRatesSettingsScreen />} />
    <Route path={FINANCE} element={<FinanceSettingsScreen />} />
    <Route path={PERKS} element={<MemberBenefits />} />
    <Route path={CONSENT_TEMPLATES} element={<ConsentTemplateLibrary />} />
    <Route
      path={`${CONSENT_TEMPLATES}/${ID}`}
      element={<ConsentTemplateView />}
    />
    <Route path={SKILLS_AND_NEEDS} element={<SkillTemplateScreen />} />
    <Route
      path={`${SKILLS_AND_NEEDS}/${SKILL_TEMPLATES}`}
      element={<SkillTemplateScreen />}
    />
    <Route
      path={`${SKILLS_AND_NEEDS}/${NEED_TEMPLATES}`}
      element={<NeedTemplateScreen />}
    />
    <Route path={PRIVACY_OFFICERS} element={<PrivacyOfficersScreen />} />
  </Route>
)
